import {
  Chip,
  ComponentColorMode,
  IconCheck,
  IconClose,
  IconUnmarked,
  IndicatorMark,
  SpaceBetween,
  spacing,
  styled,
} from '@lessonup/ui-components';
import React from 'react';
import { AnswerCardContentAnswer } from '../AnswerCardContentAnswer';

export interface AnswerCardContentProps {
  answers: string[];
  revealed: boolean;
  answerCorrectnessIndicator?: 'correct' | 'incorrect' | 'neutral';
  titleChipColorMode?: ComponentColorMode;
  title?: string;
  endSlot?: React.ReactNode;
  handleReveal?: (e: React.MouseEvent) => void;
  ariaLabel: string;
}

export const AnswerCardContent: React.FC<AnswerCardContentProps> = ({
  answers,
  revealed,
  answerCorrectnessIndicator,
  titleChipColorMode = 'neutral',
  title,
  endSlot,
  handleReveal,
  ariaLabel,
}) => {
  // TODO support answer card styles from theme
  // const { answerCards } = usePinThemeContext();

  function correctIndicator() {
    switch (answerCorrectnessIndicator) {
      case 'correct':
        return <IndicatorMark indicatorTheme="positive" content={<IconCheck />} />;
      case 'incorrect':
        return <IndicatorMark indicatorTheme="negative" content={<IconClose />} />;
      case 'neutral':
        return <IndicatorMark dashedBorder indicatorTheme="neutral" content={<IconUnmarked />} />;
      default:
        return null;
    }
  }

  return (
    <StyledContent direction="y" spacing={spacing.size8} padding={spacing.size8}>
      {(title || answerCorrectnessIndicator) && (
        <StyledHeader>
          {correctIndicator()}
          {title && <Chip text={title} colorMode={titleChipColorMode} />}
          {endSlot && <StyledEndslotWrapper>{endSlot}</StyledEndslotWrapper>}
        </StyledHeader>
      )}
      <AnswerCardContentAnswer
        revealed={revealed}
        answers={answers}
        handleReveal={handleReveal}
        ariaLabel={ariaLabel}
      />
    </StyledContent>
  );
};

const StyledContent = styled(SpaceBetween)`
  word-break: break-word;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${spacing.size4};
`;

const StyledEndslotWrapper = styled.div`
  margin-left: auto;
`;
